<template>
  <div class='result-score-component result-component'>
    <div class='result-image' v-if='displayImage()'>
      <img :src="displayImage()" alt="">
    </div>
    <div class="result-heading">
      <h2>{{ config.title }}</h2>
    </div>
    <div class="score--display-score" v-if='config.displayAs !== "none"'>
      <h2>{{ displayScore() }}</h2>
    </div>
    <div class="score--message result-message">
      {{ displayMessage() }}
    </div>
    <div class="result-breakdown" v-if='config.breakdown'>
      <result-breakdown :config='config.breakdown' :bands='config.bands'>
        <template v-slot:default>
          {{ 'ResultBreakdown subcomponent' }}
        </template>
      </result-breakdown>
    </div>
    <div class="comp-type" v-if='debugMode == true'>
      <slot name='comptype'></slot>
    </div>
  </div>
</template>
<script>
import Scoring from '../lib/Scoring.js'
import ResultBreakdown from './ResultBreakdown.vue'
export default {
  props: ['config', 'result'],
  components: {
    'result-breakdown': ResultBreakdown
  },
  mixins: [Scoring],
  data () {
    return {
      maxScore: 0,
      score: 0
    }
  },
  computed: {

  },
  methods: {

  },
  created () {
    this.maxScore = this.getMaxScore()
  }
}
</script>
<style lang='scss'>

</style>
